/**
 * Get the number of days for payment processing.
 * According to rule - if there is 0 - 2 days app should show 2 days.
 * @param days - The number of days.
 * @returns The adjusted number of days.
 */

export const getPaymentusDaysMessage = (days: number | undefined): number => {
  if (days === undefined) {
    return 5;
  }
  if (days <= 2) {
    return 2;
  }
  return days;
};
